// extracted by mini-css-extract-plugin
module.exports = {"root":"IconPhone_root__2tEcm"};